import { siteInfo } from "@/mocks/data";

export default function HeroSection() {
  return (
    <section
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20grand%20luxurious%20Chinese%20imperial%20palace%20gate%20with%20golden%20and%20deep%20crimson%20red%20theme%2C%20majestic%20architecture%20with%20ornate%20details%2C%20dramatic%20yet%20elegant%20lighting%2C%20soft%20atmospheric%20mist%2C%20dark%20mysterious%20background%20with%20warm%20golden%20glow%2C%20cinematic%20wide%20composition%2C%20premium%20luxury%20aesthetic&width=1800&height=900&seq=hero-bg-01&orientation=landscape"
          alt="大满贯官方平台入口"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="mb-4">
          <span className="inline-block bg-primary-500/20 text-primary-300 border border-primary-500/30 px-4 py-1.5 rounded-full text-xs md:text-sm font-semibold tracking-wider whitespace-nowrap">
            官方正版 · 安全直达
          </span>
        </div>
        <h1
          className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-6"
          style={{ fontFamily: "var(--font-heading)" }}
        >
          {siteInfo.title.split("_")[0]}
          <br />
          <span className="text-primary-400">正版大满贯平台直达</span>
        </h1>
        <p className="text-base md:text-lg text-white/70 max-w-2xl mx-auto mb-10 leading-relaxed">
          {siteInfo.description}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#"
            className="w-full sm:w-auto bg-primary-500 hover:bg-primary-600 text-white px-8 py-3.5 rounded-full text-base font-bold transition-all whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/30"
          >
            立即注册 · 领取福利
          </a>
          <a
            href="#features"
            className="w-full sm:w-auto border border-white/30 hover:border-white/60 text-white px-8 py-3.5 rounded-full text-base font-medium transition-all whitespace-nowrap cursor-pointer"
          >
            了解更多
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white/50 text-2xl"></i>
      </div>
    </section>
  );
}